import axiosInstance from "@app/axiosInstance";
import { useCompany } from "@app/providers/CompanyContextProvider";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { T_ReportHistoryRow } from "./types";

export const useReportHistoryQueries = () => {
  const { selectedCompany } = useCompany();
  const companyId = selectedCompany?.companyId;

  const getByReportId = (reportId: number | null) => {
    const { data, isPending } = useQuery({
      queryKey: ["reportHistory", "report", companyId, reportId],
      queryFn: async () => {
        try {
          const response = await axiosInstance.get<T_ReportHistoryRow[]>(
            `/admin/${companyId}/report/${reportId}/history`,
          );
          return response.data;
        } catch (error) {
          if (axios.isAxiosError(error) && error.response?.status === 404) {
            return [] as T_ReportHistoryRow[];
          }
          throw error;
        }
      },
      enabled: !!companyId && !!reportId,
    });
    return { history: data, isHistoryPending: isPending };
  };

  const getByEntityId = (entityId: number | null) => {
    const { data, isPending } = useQuery({
      queryKey: ["reportHistory", "entity", companyId, entityId],
      queryFn: async () => {
        const response = await axiosInstance.get<T_ReportHistoryRow[]>(
          `/admin/${companyId}/member/${entityId}/history`,
        );
        return response.data;
      },
      enabled: !!companyId && !!entityId,
    });
    return { history: data, isHistoryPending: isPending };
  };

  return { getByReportId, getByEntityId };
};
